import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined'
import PhonelinkLockIcon from '@mui/icons-material/PhonelinkLock'
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined'
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined'
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined'
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined'
import VideogameAssetOutlinedIcon from '@mui/icons-material/VideogameAssetOutlined'

export const applicationStatuses: Array<{
  value: string
  color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  icon: JSX.Element
}> = [
  { value: '', color: 'default', icon: <></> },
  { value: 'email verification', color: 'primary', icon: <MarkEmailUnreadOutlinedIcon /> },
  { value: 'sms verification', color: 'primary', icon: <PhonelinkLockIcon /> },
  { value: 'recipt validation', color: 'info', icon: <ReceiptLongOutlinedIcon /> },
  { value: 'accepted', color: 'success', icon: <CheckOutlinedIcon /> },
  { value: 'rejected', color: 'error', icon: <PriorityHighOutlinedIcon /> },
  { value: 'fraud', color: 'warning', icon: <ReportGmailerrorredOutlinedIcon /> },
  { value: 'prize draw winner', color: 'success', icon: <EmojiEventsOutlinedIcon /> },
  { value: 'prize draw looser', color: 'warning', icon: <SentimentDissatisfiedOutlinedIcon /> },
  { value: 'deleted', color: 'error', icon: <DeleteForeverOutlinedIcon /> },
  { value: 'game', color: 'info', icon: <VideogameAssetOutlinedIcon /> },
  { value: 'accepted embargo', color: 'success', icon: <CheckOutlinedIcon /> },
  { value: 'prize draw winner embargo', color: 'success', icon: <CheckOutlinedIcon /> },
  { value: 'account', color: 'info', icon: <CheckOutlinedIcon /> },
]

export enum StatusTypes {
  EmailVerification = 1,
  SmsVerification,
  ReciptValidation,
  Accepted,
  Rejected,
  Fraud,
  PrizeDrawWinner,
  PrizeDrawLoser,
  Deleted,
  Game,
  AcceptedEmbargo,
  PrizeDrawWinnerEmbargo,
  Account, // custom status for market login main application
}
